
import React from 'react'
import FeatureFlagSwitchboard from './FeatureFlagSwitchboard'
import { Card } from '../shared/components/Card'
import { Banner } from '../shared/components/Banner'

export default function Onboarding(){
  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      <h1 className="text-3xl font-bold">Developer Onboarding</h1>
      <Banner tone="info" message="Press Ctrl/⌘ + ` to open Developer Mode panel." />
      <Card title="Getting Started">
        <ol className="list-decimal pl-6 space-y-1 text-sm">
          <li>Run local services: <code>docker compose -f contrib/dev/docker-compose.dev.yml up -d postgres redis minio</code></li>
          <li>Backend: apply migrations and seed, then start API.</li>
          <li>Frontend: <code>npm run dev</code> and set <code>VITE_API_BASE</code> if needed.</li>
        </ol>
      </Card>
      <FeatureFlagSwitchboard />
    </div>
  )
}
